import { Locale } from 'components/core/locale/types';

export const VideoRecordTranslations = {
  [Locale.English]: {
    videoRecordTranslations: {
      pageTitle: 'Record Video',
      pageSubtitle: 'Caregiver Video',
      pageMainText:
        'As a caregiver, please share with us any concerns you have. Simply tell us what’s going on and how we can help from your perspective.',
    },
  },
};
